import { render, staticRenderFns } from "./dashboard-member-event.vue?vue&type=template&id=67539b72&"
import script from "./dashboard-member-event.vue?vue&type=script&lang=js&"
export * from "./dashboard-member-event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports